<template>
    <DefaultHeader />
    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container">
        <div class="flex-md-row flex-sm-row-reverse card shadow my-2 p-3 bg-white rounded">
            <div>
                <VehicleNameDisplay :balise="baliseInfo" class="justify-content-center align-self-center" />
                <hr class="d-lg-none" />
            </div>
            <div class="flex-fill align-items-center me-2">
                <FullDriveDisplay :baliseDrive="driveInfo" />
            </div>
            <div class="d-flex justify-content-center mt-2 mt-md-0">
                <MapLinkDisplay :link="'/drivemap/' + driveInfo.id" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <TemperatureChart v-if="this.baliseInfo.id" :baliseId="this.baliseInfo.id"
                    :startDate="this.driveInfo.startDate" :endDate="this.driveInfo.endDate"
                    :title="'Température du trajet'" />
            </div>
            <div class="col-md-6 col-sm-12">
                <SpeedChart v-if="this.baliseInfo.id" :baliseId="this.baliseInfo.id"
                    :startDate="this.driveInfo.startDate" :endDate="this.driveInfo.endDate"
                    :title="'Vitesse du trajet'" />
            </div>
        </div>
        <div class="row d-flex justify-content-center d-none d-md-block">
            <div class="col-12">
                <PositionsList v-if="this.baliseInfo.id" :baliseId="this.baliseInfo.id"
                    :givenStartDate="this.driveInfo.startDate" :givenEndDate="this.driveInfo.endDate" :order="'ASC'"
                    :displayCounter="true" />
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import TemperatureChart from '@/components/charts/TemperatureChart.vue'
import SpeedChart from '@/components/charts/SpeedChart.vue'
import PositionsList from '@/components/PositionsList.vue'
import FormatHelper from '@/helpers/format.helper.js'
import BaliseService from '@/services/balise.service'
import DriveService from '@/services/drive.service'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import FullDriveDisplay from '@/components/display/FullDriveDisplay.vue'
import MapLinkDisplay from '@/components/display/MapLinkDisplay.vue'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        PositionsList,
        FullDriveDisplay,
        VehicleNameDisplay,
        TemperatureChart,
        SpeedChart,
        MapLinkDisplay
    },
    data() {
        return {
            baliseInfo: [],
            driveInfo: []
        }
    },
    mounted() {
        this.getDriveInfos()
    },
    methods: {
        getBaliseInfos(baliseId) {
            BaliseService.getBaliseInfo(baliseId)
                .then(response => {
                    this.baliseInfo = FormatHelper.baliseInfoFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        getDriveInfos() {
            DriveService.getDriveInfo(this.$route.params.id)
                .then(response => {
                    this.driveInfo = FormatHelper.driveInfoFormat(response.data)
                    this.getBaliseInfos(response.data.baliseId)
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
}
</script>